<script setup></script>
<template>
  <button
    class="block w-full rounded-md text-white font-medium py-2.5 px-5.5 bg-blue-600 hover:bg-blue-700 transition-all duration-200"
  >
    <slot />
  </button>
</template>
